import React, { useEffect } from 'react';
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import ViewMunicipality from '../components/ViewMunicipality';
import { getMunicipality } from '../hooks/GetMunicipality';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { setMunicipality } from '../redux/municipialitySlice';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';

export default function MunicipalityPage() {
  const isAuthenticated = useIsAuthenticated();
  const auth: string = useAuthHeader() || '';
  const dispatch = useDispatch();

  const municipality = useSelector(
    (state: RootState) => state.municipality.selectedMunicipality
  );

  useEffect(() => {
    if (!isAuthenticated) {
      window.location.reload();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!municipality) {
      loadMunicipalities();
    }
  }, []);

  const loadMunicipalities = async () => {
    const municipality = await getMunicipality(auth, dispatch);
    if (municipality) dispatch(setMunicipality(municipality));
  };

  return <>{isAuthenticated && <ViewMunicipality />}</>;
}
